import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { envValue } from '../../../config/envUtils';
import { httpClient } from '../../../lib/utils';
import * as ActionTypes from '../../constants/ActionTypes';
import IframePreview from './IFramePreview';
import DashboardPreview from '../common/DashboardPreview';

const FRONTMAN_URL = envValue('FRONTMAN_URL');

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.openPreviewInNewWindow = this.openPreviewInNewWindow.bind(this);
    }

    componentDidMount() {
        const { hotelList } = this.props;

        if (hotelList.length >= 100) {
            this.paginate(100, 100, hotelList);
        }
    }

    paginate(offset, perPage, acc) {
        const { chainid, onReceiveHotelList } = this.props;

        return httpClient
            .get(`${FRONTMAN_URL}/admin/hotels?view=Lookup&chainId=${chainid}&pageStart=${offset}&pageSize=${perPage}`)
            .then(response => {
                const accumulator = acc.concat(response.data.hotels);
                if (response.data.pagination.total > response.data.pagination.start + response.data.pagination.size) {
                    return this.paginate(
                        response.data.pagination.start + response.data.pagination.size,
                        perPage,
                        accumulator
                    );
                }

                return onReceiveHotelList(accumulator);
            });
    }

    openPreviewInNewWindow(ngbeUrl) {
        return window.open(ngbeUrl);
    }

    render() {
        return (
            <div className="dashboard-container">
                <DashboardPreview />
            </div>
        );
    }
}

Dashboard.propTypes = {
    chainid: PropTypes.string,
    hotelList: PropTypes.array,
    onReceiveHotelList: PropTypes.func.isRequired
};

Dashboard.defaultProps = {
    chainid: '',
    hotelList: []
};

const mapDashboardStateToProps = state => {
    return {
        chainid: state.app.selected.chain.Id,
        hotelid: state.app.selected.selectedHotel.id,
        hotelList: state.manage.hotelList
    };
};

const mapDashboardDispatchToProps = dispatch => {
    return {
        onReceiveHotelList: hotelList => {
            dispatch({ type: ActionTypes.LOGIN_SET_HOTELLIST, hotelList });
        }
    };
};

export default connect(mapDashboardStateToProps, mapDashboardDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard.js